import { FunctionComponent, KeyboardEvent } from 'react'
import classNames from 'classnames'
import { Icon } from '../primitives/Icon/Icon'
import { Text } from '../primitives/Text/Text'
import { useActions } from 'src/hooks/useActions'
import { AddressSectionProps } from './AddressSection.types'
import './AddressSection.scss'

export const AddressSection: FunctionComponent<AddressSectionProps> = ({
  leftIcon,
  title,
  address,
  rightIcon,
  actions
}) => {
  const { onClick } = useActions(actions)

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick?.()
    }
  }

  return (
    <div
      className={classNames('core-ux-address-section', {
        clickable: !!onClick
      })}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}>
      <div className="core-ux-address-section__left-content">
        {leftIcon && (
          <Icon {...leftIcon} className="core-ux-address-section__left-icon" />
        )}
        <div className="core-ux-address-section__main-content">
          <Text {...title} />
          <Text {...address} />
        </div>
      </div>
      {rightIcon && (
        <Icon {...rightIcon} className="core-ux-address-section__right-icon" />
      )}
    </div>
  )
}
